import moment from 'moment';

let APIDateFormats = /*#__PURE__*/function (APIDateFormats) {
  APIDateFormats["date"] = "YYYY-MM-DD";
  APIDateFormats["complete"] = "YYYY-MM-DDTHH:mm:ssZ";
  return APIDateFormats;
}({});
function parseApiDate(date, dateFormat) {
  return date ? moment(date, dateFormat) : undefined;
}
function parseApiDuration(duration) {
  return duration ? moment.duration(duration) : undefined;
}

export { APIDateFormats, parseApiDate, parseApiDuration };
//# sourceMappingURL=Date.js.map
